"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSuccess = void 0;
var React = __importStar(require("react"));
var IconSuccess = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { id: "Informative/ic_success", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M12,21 C16.963,21 21,16.963 21,12 C21,7.037 16.963,3 12,3 C7.037,3 3,7.037 3,12 C3,16.963 7.037,21 12,21 Z M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z M15.4404,8.2969 C15.7784,7.9959 16.4694,7.8679 16.8074,8.1689 C17.1444,8.4699 17.0014,8.9569 16.6634,9.2579 L10.0934,15.7729 C9.9304,15.9169 9.7104,15.9969 9.4824,15.9969 C9.4474,15.9969 9.4134,15.9959 9.3784,15.9919 C9.1144,15.9639 8.8794,15.8279 8.7424,15.6259 L7.1244,12.1309 C6.8774,11.7669 7.0084,11.2929 7.4174,11.0729 C7.8254,10.8529 8.3574,10.9699 8.6044,11.3339 L9.6514,13.3459 L15.4404,8.2969 Z", id: "success", fill: "#464650" }),
        React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 })))); };
exports.IconSuccess = IconSuccess;
exports.IconSuccess.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconSuccess;
